import { buildViewAsUrl } from "@/auth/viewAs";
import { ActionIcon, Tooltip } from "@mantine/core";
import { IconEye } from "@tabler/icons-react";

type Props = {
  userId: string;
  userName: string | null;
  isTestUser: boolean;
};

export function ViewAsUserButton({ userId, userName, isTestUser }: Props) {
  return (
    <Tooltip label={isTestUser ? "이 테스트 유저로 사용하기" : "이 사용자로 보기 (보기 전용)"}>
      <ActionIcon
        variant="subtle"
        color="gray"
        size="md"
        aria-label="이 사용자로 보기"
        onClick={(e) => {
          e.stopPropagation();
          window.open(buildViewAsUrl(userId, userName ?? "", isTestUser), "_blank");
        }}
      >
        <IconEye size={16} />
      </ActionIcon>
    </Tooltip>
  );
}
